import { Button } from '@seen/ui'
import { IconMenu } from '@tabler/icons-react'
import type { JSX } from 'react'
import { NavigationMenu } from '#src/components/core/navigation-menu/NavigationMenu.tsx'
import { NavigationMenuContent } from '#src/components/core/navigation-menu/NavigationMenuContent.tsx'
import { NavigationMenuItem } from '#src/components/core/navigation-menu/NavigationMenuItem.tsx'
import { NavigationMenuLink } from '#src/components/core/navigation-menu/NavigationMenuLink.tsx'
import { NavigationMenuList } from '#src/components/core/navigation-menu/NavigationMenuList.tsx'
import { NavigationMenuTrigger } from '#src/components/core/navigation-menu/NavigationMenuTrigger.tsx'
import type { PatientNavigationItem } from '#src/hooks/usePatientNavigationItems.ts'

export function PatientNavigationButton({
  buttonClassName,
  navigationItems,
}: {
  buttonClassName?: string
  navigationItems: PatientNavigationItem[]
}): JSX.Element {
  return (
    <NavigationMenu orientation="vertical" viewportClassName="mr-3 z-50">
      <NavigationMenuList>
        <NavigationMenuItem value="default">
          <NavigationMenuTrigger asChild>
            <Button variant="ghost" size="icon" className={buttonClassName}>
              <IconMenu size={16} />
            </Button>
          </NavigationMenuTrigger>
          <NavigationMenuContent className="flex flex-col p-2">
            {navigationItems.map(({ label, to }) => (
              <NavigationMenuLink
                key={to}
                to={to}
                className="w-44 px-2 py-1.5"
                end={to === ''}
              >
                {label}
              </NavigationMenuLink>
            ))}
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  )
}
